import React, { Component } from "react";
import { _callApiMessage } from "GlobalFunction";
import axios from "axios";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import GlobalValue from "GlobalValue";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Chat from "@material-ui/icons/Chat";
import low_priority from "@material-ui/icons/LowPriority";
import email from "@material-ui/icons/Email";
import Build from "@material-ui/icons/Build";
import chrome_reader_mode from "@material-ui/icons/ChromeReaderMode";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import tabsStyle from "assets/jss/material-kit-react/components/tabsStyle.jsx";

import DocPage01 from "views/DocPage/DocPage01.jsx";
import DocPage02 from "views/DocPage/DocPage02.jsx";
import DocPage03 from "views/DocPage/DocPage03.jsx";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}
const lastCheckTime = "";
class LoginPage extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      txtId: "",
      txtPw: "",
      openDialog: false,
      Edocument01: [],
      Edocument02: [],
      Edocument03: [],
      Loading: false
    };
  }

  componentDidMount = async () => {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    // console.log("componentDidMount", this.props);
    GlobalValue.USER_INFO = this.props.location.state.detail;
    localStorage.setItem("USERINFO", JSON.stringify(GlobalValue.USER_INFO));
    // console.log("??", this.props.classes);
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
    await this.getInitData();
  };

  getInitData = async () => {
    var RESIVE_USER_LIST = [];
    var body = {
      SCDBName: GlobalValue.USER_INFO.SCDBName,
      SCHostIp: GlobalValue.USER_INFO.SCHostIp,
      SCCode: GlobalValue.USER_INFO.SCCode,
      STLastDateTime: "",
      STLastDateTimeMilliSecond: ""
    };
    // console.log("body", body);
    await _callApiMessage(
      "list/e-doc/staff",
      `StaffObj=${JSON.stringify(body)}`
    )
      .then(responsBody => {
        // console.log("list/e-doc/staff/find", responsBody);
        if (responsBody.type === "N") {
        } else {
          RESIVE_USER_LIST = responsBody.data;
          localStorage.setItem("User", JSON.stringify(RESIVE_USER_LIST));
        }
      })
      .catch(error => {
        console.error(error);
      });

    body =
      "SCDBName=" +
      GlobalValue.USER_INFO.SCDBName +
      "&SCHostIp=" +
      GlobalValue.USER_INFO.SCHostIp;
    await _callApiMessage("list/jikcheck", body)
      .then(responsBody => {
        if (responsBody.code === "00") {
          if (responsBody.type === "A") {
            GlobalValue.jikcheck = responsBody.data;
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
    await _callApiMessage("list/buseo", body)
      .then(responsBody => {
        if (responsBody.code === "00") {
          if (responsBody.type === "A") {
            GlobalValue.buseo = responsBody.data;
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
    this.getDocList();
  };
  getDocList = async () => {
    // this.setState({ Loading: false });
    let result = "";
    let body = `SCDBName=${GlobalValue.USER_INFO.SCDBName}&SCHostIp=${
      GlobalValue.USER_INFO.SCHostIp
    }&STCode=${GlobalValue.USER_INFO.SUSTCode}&lastCheckTime=${lastCheckTime}`;
    let uri = "e-doc/getEdoc";
    await _callApiMessage(uri, body).then(data => {
      if (data.code === "00") {
        if (data.type === "A") {
          let edocument = data.data;

          // console.log(
          //   edocument.filter(item => {
          //     return item.EDEG1Code >= 200 && item.EDEG1Code < 300;
          //   })
          // );
          this.setState({
            Edocument01: edocument.filter(item => {
              return item.EDEG1Code >= 100 && item.EDEG1Code < 200;
            }),
            Edocument02: edocument.filter(item => {
              return item.EDEG1Code >= 200 && item.EDEG1Code < 300;
            }),
            Edocument03: edocument.filter(item => {
              return item.EDEG1Code >= 100 && item.EDEG1Code < 400;
            }),
            Loading: true
          });
          result = true;
        }
      } else {
        result = false;
      }
    });
    // console.log("thisstate", this.state);

    return result;
  };
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };
  handleClose = () => {
    this.setState({ openDialog: false });
  };
  handleLogout = () => {
    localStorage.clear();
    this.props.history.goBack();
  };
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div className={classes.docPageContainer}>
        {this.state.Loading ? (
          <CustomTabs
            globalValue={GlobalValue}
            headerColor="primary"
            handleLogout={this.handleLogout}
            tabs={[
              {
                tabName: "전자 결재",
                tabIcon: chrome_reader_mode,
                tabContent: (
                  <DocPage01
                    edocument={this.state.Edocument01}
                    initDocument={this.getDocList}
                  />
                )
              },
              {
                tabName: "업무 요청",
                tabIcon: low_priority,
                tabContent: (
                  <DocPage02
                    edocument={this.state.Edocument02}
                    initDocument={this.getDocList}
                  />
                )
              },
              {
                tabName: "전자 문서함",
                tabIcon: email,
                tabContent: (
                  <DocPage03
                    edocument={this.state.Edocument03}
                    initDocument={this.getDocList}
                  />
                )
              }
            ]}
          />
        ) : null}
      </div>
    );
  }
}

export default withStyles(tabsStyle)(LoginPage);
